import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Button from 'components/Button';

import RoseLogo from 'assets/images/logo/Logo-JML-Rose.svg';

import Wrapper from './Wrapper';

function Footer({ history }) {
  return (
    <Wrapper>
      <div className="info-group">
        <div className="logo-wrapper">
          <img alt="Rose-Logo" src={RoseLogo} />
        </div>
        <div className="information">
          <p>JML ROSE PTY LTD ACN 620 307 217&nbsp;&nbsp;|&nbsp;&nbsp;AN INCORPORATED LEGAL PRACTICE</p>
        </div>
      </div>
      <div className="button-group">
        <Button name="Contact" onClick={() => history.push('/contact')} rightMargin />
        <Button name="Client agreement and privacy policy" onClick={() => history.push('/privacy')} />
      </div>
    </Wrapper>
  );
}

Footer.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js